// @ts-nocheck
import { Plugin } from '/app/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','layout','layoutActionRef','request',],
});

export { plugin };
